import {iot, mqtt} from 'aws-iot-device-sdk-v2';

export class MQTTConnection {
    private connection: mqtt.MqttClientConnection | null = null;

    private subscriptions: Set<string> = new Set();

    private readonly clientId: string;

    private readonly endpoint: string;

    public token: string;

    constructor(endpoint: string, token: string) {
        this.token = token;
        this.endpoint = endpoint;
        this.clientId = `agent-portal-${Date.now()}-${Math.random().toString(16).slice(2)}`;

        console.log('Initializing MQTT with clientId:', this.clientId);
    }

    getConnection() {
        return this.connection;
    }
    async connect(token: string, agentEmail: string) {
        console.log('Attempting to connect to:', this.endpoint);

        const config = iot.AwsIotMqttConnectionConfigBuilder.new_with_websockets()
            .with_clean_session(true)
            .with_client_id(this.clientId)
            .with_endpoint(this.endpoint)
            .with_custom_authorizer(
                agentEmail,
                `${process.env.NEXT_PUBLIC_ATHENA_STAGE_NAME}-${process.env.NEXT_PUBLIC_MQTT_AUTHORIZER}`,
                '',
                token,
            )
            .with_keep_alive_seconds(30)
            .build();

        const client = new mqtt.MqttClient();

        this.connection = client.new_connection(config);

        this.connection.on('disconnect', () => {
            console.log('MQTT Disconnected');
        });

        this.connection.on('error', (error) => {
            console.log('ERROR:', error);
        });

        try {
            await this.connection.connect();
            console.log('Connection established successfully');
        } catch (err) {
            console.error('Connection failed:', err);
            throw err;
        }

        return this.connection;
    }

    async subscribe(topic: string, callback: (topic: string, payload: any) => void) {
        if (!this.connection) {
            throw new Error('Not connected');
        }

        try {
            if (topic) {
                await this.connection.subscribe(topic, mqtt.QoS.AtLeastOnce, (t, p) => {
                    try {
                        const message = new TextDecoder().decode(p);
                        const parsedMessage = JSON.parse(message);
                        callback(t, parsedMessage);
                    } catch (err) {
                        console.log('Error processing message:', err);
                    }
                });
            }
        } catch (err) {
            console.log('Subscription failed:', err);
            throw err;
        }
        this.subscriptions.add(topic);
    }

    async disconnect() {
        if (this.connection) {
            console.log('Disconnecting MQTT...');
            try {
                await this.connection.disconnect();
                console.log('Disconnected successfully');
            } catch (err) {
                console.error('Disconnect failed:', err);
            }
        }
    }

    async unsubscribe(topic: string) {
        if (!this.connection) {
            console.warn('Attempting to unsubscribe without connection');
            return;
        }

        if (!this.subscriptions.has(topic)) {
            console.warn(`No active subscription found for topic: ${topic}`);
            return;
        }

        try {
            if (this.connection) {
                await this.connection.unsubscribe(topic);
                console.log(`Successfully unsubscribed from ${topic}`);
            }
        } catch (err) {
            console.error(`Error while unsubscribing from ${topic}:`, err);
            throw err;
        } finally {
            this.subscriptions.delete(topic);
        }
    }
}
